import { useEffect, useState } from "react";
import LicenseService from "../../services/LicensesService";
import Select from "../Select/Select";

export function LicenseTypeSelector({ value, onChange, isSubmitting = false, ...props }) {
   const [types, setTypes] = useState([]);

   async function fetchTypes() {
      const response = await LicenseService.getTypes();
      setTypes(response.data);
   }

   useEffect(() => {
      fetchTypes();
   }, []);

   return (
      <Select
         labelText="Tipo da Licença *"
         value={value}
         onChange={({ target }) => {
            onChange({ target: { value: target.value } })
         }}
         disabled={props.type === "consulta" || isSubmitting}
         required={false}
         options={types?.map((type) => ({
            value: type.code,
            text: type.name,
         }))}
         error={props.error}
      />
   );
}